// Styles
import styles from './SimpleImageCell.module.css';

/**
 * Simple image cell component for SimpleTable
 * @param {object} props
 * @param {string} props.imageUrl - Image source URL
 * @param {string} props.link - Link URL
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element}
 */
function SimpleImageCell({
  imageUrl,
  link,
  className = '',
}) {
  return (
    <a href={link} className={`${styles['simple-image-cell-link']} ${className}`} aria-label="View image">
      <img
        src={imageUrl}
        alt=""
        className={styles['simple-image-cell-image']}
      />
    </a>
  );
}

export default SimpleImageCell;
